import { isDataFetchError } from './DataFetchError';
import { HttpError } from './HTTPErrors';

const GENERIC_ERROR_MESSAGE =
  'Something went wrong. Please try again or contact support if the problem continues.';

const PLACEHOLDER_ERROR_MESSAGES = new Set(['undefined', 'null']);

const TECHNICAL_MESSAGE_FRAGMENTS = ['/api/', 'http://', 'https://'] as const;

/**
 * Returns user-facing copy for an error, hiding raw URLs and technical noise.
 */
export function getUserSafeErrorMessage(error: Error): string {
  if (isDataFetchError(error)) {
    return error.message;
  }

  if (!(error instanceof HttpError)) {
    return GENERIC_ERROR_MESSAGE;
  }

  const message = error.message.trim();
  const normalizedMessage = message.toLowerCase();

  if (
    message.length === 0 ||
    PLACEHOLDER_ERROR_MESSAGES.has(normalizedMessage) ||
    TECHNICAL_MESSAGE_FRAGMENTS.some((fragment) =>
      normalizedMessage.includes(fragment),
    )
  ) {
    return GENERIC_ERROR_MESSAGE;
  }

  return message;
}
